import {Component} from '@angular/core';
import {AbstractStudyComponent} from "../../abstract-study.component";
import {CompetitiveIntelligenceStudy} from "../competitive-intelligence-study";
import {CategoryName} from "../../category-name";
import {StudiesNames} from "../../studies-names";
import {of} from "rxjs";

@Component({
    selector: 'kiwi-maintenance-quality-comparison',
    templateUrl: './maintenance-quality-comparison.component.html',
    styleUrls: ['./maintenance-quality-comparison.component.scss'],
    host: { 'class': 'cell auto grid-y' },
    standalone: false
})
export class MaintenanceQualityComparisonComponent extends AbstractStudyComponent<CompetitiveIntelligenceStudy> {
    constructor() {
        super(CategoryName.COMPETITIVE_INTELLIGENCE, of(StudiesNames.MAINTENANCE_QUALITY_COMPARISON));
    }
}
